import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CheckIcon from "@mui/icons-material/Check";

import {
  Box,
  Button,
  Checkbox,
  Chip,
  FilledInput,
  FormControl,
  IconButton,
  Input,
  InputLabel,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  TextareaAutosize,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";
import moment from "moment";
import { useEffect, useState } from "react";
import DataTableItem from "react-data-table-component";
import localizationStrings from "../../utils/localizations";
import { baseUrl } from "../../utils/constants";

export default function PaymentLogsData() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  // const [modalVisible, setModalVisible] = useState(false);
  // const [selected, setSelected] = useState(null);
  // const [planName, setPlanName] = useState("");
  // const [planDescription, setPlanDescription] = useState("");
  // const [planFeatures, setPlanFeatures] = useState([]);
  // const [planPrice, setPlanPrice] = useState("");
  // const [planDiscount, setPlanDiscount] = useState("");
  // const [planFinalPrice, setPlanFinalPrice] = useState("");
  // const [isActive, setIsActive] = useState(false);

  // const [modalLoading, setModalLoading] = useState(false);

  // const handleOpen = (item) => {
  //   setSelected(item);
  //   setPlanName(item.plan_name);
  //   setPlanDescription(item.plan_description);
  //   setPlanFeatures(item.plan_features);
  //   setPlanPrice(item.plan_price);
  //   setPlanDiscount(item.plan_discount);
  //   setPlanFinalPrice(item.plan_final_price);
  //   setIsActive(item.is_active);

  //   setModalVisible(true);
  // };

  // const handleClose = () => {
  //   setSelected(null);
  //   setPlanName("");
  //   setPlanDescription("");
  //   setPlanFeatures([]);
  //   setPlanPrice("");
  //   setPlanDiscount("");
  //   setPlanFinalPrice("");
  //   setIsActive(false);
  //   setModalVisible(false);
  // };

  const getPaymentPlans = async (silent = false) => {
    if (!silent) setLoading(true);
    try {
      const data = await axios.get(baseUrl + "premium-codes/logs");
      if (data.data.success) {
        setData(data.data.data);
        setFilteredData(data.data.data);
      }
      if (!silent) setLoading(false);
    } catch (e) {
      if (!silent) setLoading(false);
      console.warn(e);
    }
  };
  useEffect(() => {
    getPaymentPlans();
    const int = setInterval(() => {
      getPaymentPlans(true);
    }, 60 * 1000);
    return () => clearInterval(int);
  }, []);

  // const pressSave = async () => {
  //   setModalLoading(true);
  //   if (isActive) {
  //     for (let i = 0; i < data.length; i++) {
  //       if (data[i].is_active) {
  //         if (selected && selected.id === data[i].id) continue;
  //         alert("Only one plan can be active at a time");
  //         setModalLoading(false);
  //         return;
  //       }
  //     }
  //   }
  //   try {
  //     const bdy = {
  //       plan_name: planName,
  //       plan_description: planDescription,
  //       plan_features: planFeatures,
  //       plan_price: planPrice,
  //       plan_discount: planDiscount,
  //       plan_final_price: planFinalPrice,
  //       is_active: isActive,
  //     };
  //     // const bdy = new FormData();

  //     if (selected) bdy["id"] = selected.id;
  //     if (selected) {
  //       await axios.put(baseUrl + "payment-plans", bdy);
  //     } else {
  //       await axios.post(baseUrl + "payment-plans", bdy);
  //     }
  //     await getPaymentPlans(true);
  //     setModalLoading(false);
  //     handleClose();
  //   } catch (e) {
  //     setModalLoading(false);
  //     console.warn(e);
  //     if (e.response?.data?.message) {
  //       alert(e.response.data.message);
  //     } else {
  //       alert("Error: Unable to save");
  //     }
  //   }
  // };

  if (loading) {
    return (
      <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
        <div className="loader"></div>
      </div>
    );
  }
  const handleSearch = () => {
    setFilteredData(data.filter((v) => JSON.stringify(v).toLocaleLowerCase().includes(search.toLocaleLowerCase())));
  };

  return (
    <div style={{ height: "calc(100vh - 60px)", width: "100%", padding: 30 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", mb: "15px" }}>
          {/* <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} onClick={() => setModalVisible(true)}> */}
          {/* <Button variant="contained" onClick={() => setModalVisible(true)}>
            {localizationStrings.Add}
          </Button> */}
          {/* </Box> */}
          <div style={{ flex: 1, display: "flex" }} />
          <Input
            style={{ backgroundColor: "#fff" }}
            placeholder={localizationStrings.Search}
            color="primary"
            value={search}
            onChange={(e) => setSearch(e.nativeEvent.target.value)}
            endAdornment={
              <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <IconButton
                  onClick={() => {
                    setFilteredData(data);
                    setSearch("");
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton type="submit" onClick={handleSearch}>
                  <SearchIcon />
                </IconButton>
              </Box>
            }
          />
        </Box>
      </form>
      {data.length === 0 ? (
        <div className="tracking-container" style={{ alignItems: "center", justifyContent: "center" }}>
          <h3 style={{ textAlign: "center" }}>No Logs</h3>
        </div>
      ) : (
        <DataTableItem
          data={filteredData}
          columns={[
            {
              selector: (row) => row.user_id?.full_name ?? row.user_id,
              name: <div>User</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },

            {
              selector: (row) => row.purchase_type,
              name: <div>Purchase Type</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },

            {
              selector: (row) => row.current_status,
              name: <div>Current Status</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },

            {
              selector: (row) =>
                row.purchase_store_data ? (
                  <div
                    onClick={() => {
                      if (row.purchase_store_data) {
                        const storeData = JSON.stringify(row.purchase_store_data, null, 2);
                        const newWindow = window.open();
                        newWindow.document.write("<pre style='font-size: 12px'>" + storeData + "</pre>");
                      } else {
                        alert("No store data available for this user.");
                      }
                    }}
                  >
                    Open Store Data
                  </div>
                ) : (
                  ""
                ),
              name: <div>Store Data</div>,
              sortable: true,
              grow: 1,
              wrap: true,
            },

            {
              selector: (row) => moment(row.purchase_date).format("DD/MM/YYYY HH:mm:ss"),
              name: <div>{localizationStrings.CreatedAt}</div>,
              sortable: true,
              sortFunction: (a, b) => moment(a).unix() - moment(b).unix(),
              grow: 1,
              wrap: true,
            },

            {
              selector: (row) => moment(row.last_updated).format("DD/MM/YYYY HH:mm:ss"),
              name: <div>Last Updated At</div>,
              sortable: true,
              sortFunction: (a, b) => moment(a).unix() - moment(b).unix(),
              grow: 1,
              wrap: true,
            },
            {
              selector: (row) => (
                <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "column", md: "column", lg: "row" } }}>
                  {/* <Button variant='outlined' startIcon={<VisibilityIcon />}>
                  View
                </Button>
                <div style={{ width: 10, height: 10 }} /> */}
                  {/* <Button style={{ color: "black" }} variant="outlined" startIcon={<EditIcon />} onClick={() => handleOpen(row)}>
                    {localizationStrings.Edit}
                  </Button>
                  <div style={{ width: 10, height: 10 }} /> */}
                  {row.payment_status == "pending" && (
                    <Button
                      style={{ color: "black" }}
                      variant="outlined"
                      startIcon={<CheckIcon />}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to accept payment!")) {
                          setLoading(true);
                          axios
                            .post(baseUrl + "payment-logs/" + row._id + "/accept")
                            .then((rslt) => {
                              if (!rslt.data.success) {
                                alert(rslt.message || "Something went wrong");
                              }
                              getPaymentPlans();
                            })
                            .catch((err) => {
                              alert(err.response?.data?.message || err.message || "Error: Unable to accept payment");
                              setLoading(false);
                            });
                        }
                      }}
                    >
                      Accept Payment
                    </Button>
                  )}
                  <div style={{ width: 10, height: 10 }} />
                  {row.payment_status == "pending" && (
                    <Button
                      style={{ color: "black" }}
                      variant="outlined"
                      startIcon={<CloseIcon />}
                      onClick={() => {
                        if (window.confirm("Are you sure you want to reject payment!")) {
                          setLoading(true);
                          axios
                            .post(baseUrl + "payment-logs/" + row._id + "/reject")
                            .then((rslt) => {
                              if (!rslt.data.success) {
                                alert(rslt.message || "Something went wrong");
                              }
                              getPaymentPlans();
                            })
                            .catch((err) => {
                              alert(err.response?.data?.message || err.message || "Error: Unable to reject payment");
                              setLoading(false);
                            });
                        }
                      }}
                    >
                      Reject Payment
                    </Button>
                  )}
                </Box>
              ),
              name: <div>{localizationStrings.Options || "Options"}</div>,
              sortable: true,
              grow: 2,
              wrap: true,
            },
          ]}
          highlightOnHover
          fixedHeader
          pagination
          responsive
          style={{ height: "calc(100vh - 82px)" }}
          customStyles={{
            headCells: { style: { backgroundColor: "#4A4B6A", color: "#000", fontSize: "11px" } },
            responsiveWrapper: { style: { height: "calc(100vh - 220px)" } },
            tableWrapper: { style: { width: "max(1000px, 100%)" } },
            cells: { style: { fontSize: "11px" } },
          }}
          paginationComponent={({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => (
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end", minHeight: 56 }}>
              <Typography sx={{ margin: "0 24px", color: "rgba(0, 0, 0, 0.54)", fontSize: "13px" }}>
                {(currentPage - 1) * rowsPerPage + 1}-{currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage} of {rowCount}
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{ fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`, color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})` }}
                  onClick={() => onChangePage(1)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                    <path fill="none" d="M24 24H0V0h24v24z"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{ fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`, color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})` }}
                  onClick={() => onChangePage(currentPage - 1)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(currentPage + 1)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(Math.ceil(rowCount / rowsPerPage))}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                  </svg>
                </button>
              </div>
            </Box>
          )}
        />
      )}
      {/* {modalVisible && (
        <div className="modal-container">
          <div aria-hidden="true" className="modal-back" onClick={handleClose}></div>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "90%", sm: "70%", md: "60%", lg: "40%", xl: "30%" },
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: 24,
              p: 4,
            }}
          >
            <Box sx={{ position: "absolute", top: 20, [localizationStrings.getLanguage() === "ar" ? "left" : "right"]: 20 }}>
              <IconButton onClick={handleClose}>
                <CloseIcon />
              </IconButton>
            </Box>
            <Typography id="modal-modal-description" sx={{ mt: 5, textAlign: "center", fontWeight: "700", fontSize: 18 }}>
              {localizationStrings.Add}
            </Typography>
            <Box style={{ flex: 1, display: "flex", flexDirection: "column" }}>
              <div style={{ height: 20 }} />
            
              <div style={{ height: 20 }} />
              <TextField label={"Payment Plan Name"} variant="filled" value={planName} onChange={(e) => setPlanName(e.target.value)} />
              <div style={{ height: 20 }} />
              <TextField
                label={"Payment Plan Description"}
                variant="filled"
                value={planDescription}
                onChange={(e) => setPlanDescription(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <TextField
                label={"Payment Plan Features"}
                variant="filled"
                value={planFeatures.join("\n")}
                onChange={(e) => setPlanFeatures(e.target.value.split("\n"))}
                multiline
                minRows={2}
              />
              <div style={{ height: 20 }} />
              <TextField label={"Payment Plan Price"} variant="filled" value={planPrice} onChange={(e) => setPlanPrice(e.target.value)} />
              <div style={{ height: 20 }} />
              <TextField label={"Payment Plan Discount"} variant="filled" value={planDiscount} onChange={(e) => setPlanDiscount(e.target.value)} />
              <div style={{ height: 20 }} />
              <TextField
                label={"Payment Plan Final Price"}
                variant="filled"
                value={planFinalPrice}
                onChange={(e) => setPlanFinalPrice(e.target.value)}
              />
              <div style={{ height: 20 }} />
              <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <Checkbox checked={isActive} onChange={(e) => setIsActive(e.target.checked)} />
                <Typography>Is Active</Typography>
              </div>
              <div style={{ height: 20 }} />
              {modalLoading ? (
                <div style={{ alignItems: "center", justifyContent: "center", display: "flex" }}>
                  <div className="loader" />
                </div>
              ) : (
                <Button onClick={() => pressSave()} variant="contained">
                  {localizationStrings.Save}
                </Button>
              )}
              <div style={{ height: 20 }} />
            </Box>
          </Box>
        </div>
      )} */}
    </div>
  );
}
